import { render } from "./comments.vue?vue&type=template&id=3469ea63&scoped=true&ts=true"
import script from "./comments.vue?vue&type=script&lang=ts"
export * from "./comments.vue?vue&type=script&lang=ts"

import "./comments.vue?vue&type=style&index=0&id=3469ea63&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3469ea63"]])

export default __exports__